<template>
  <div id="upload" style="padding: 0 1em;">
        
        <div class="div-memo"
          v-if="null != docRecord">
          {{docRecord.name}}{{docRecord.title}} 您好：
          <br/><br/>
          <el-row>
            檔案格式：<font style="color:#411c35; font-weight: bolder;">PDF、JPG</font> 檔案 <br/>
          </el-row>
          <el-row>
            檔案大小：<font style="color:#411c35; font-weight: bolder;">10MB</font> <br/><br/>
          </el-row>
          <el-row>
            參考格式：<a :href="'./WebApi/Tools/ShowSystemDoc/'.concat(sysId).concat('/8')" target="_blank"
                         :title="setting.templateFile[0].codeName"
                         v-if="null != setting.templateFile">下載檔案</a>
          </el-row> <br/><br/>    
          <el-row>
            目前狀態：<b style="color: #1a6840;">{{currentStatus}}</b>
          </el-row> <br/>
        </div>
        
        <table class="div-memo"
          v-if="(null != docRecord) && (2 > docRecord.status)">
          <tr>
            <td>
             <!-- <el-upload
                class="upload-demo"
                ref="upload"
                :name="'r' + this.user.deptID"
                action="./WebApi/Tools/UploadV2"
                accept=".pdf,.jpg"                
                :on-success="handleAvatarSuccess"
                :before-upload="onBeforeUpload"
                :on-remove="handleRemove"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList">
                <el-button size="small" type="primary">點擊上傳</el-button>
                <div slot="tip" class="el-upload__tip">(請以 PDF 、JPG 格式之檔案上傳，檔案大小以 10MB 為限)</div>
              </el-upload> -->
              <el-upload
                class="upload-demo"
                drag
                ref="upload"
                :name="'r' + this.user.deptID"
                action="./WebApi/Tools/UploadV2"
                accept=".pdf,.jpg,.doc,.docx"                         
                :on-success="handleAvatarSuccess"
                :on-error="errorfun"
                :before-upload="onBeforeUpload"
                :on-remove="handleRemove"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">將文件拖到此處，或<em>點擊瀏覽</em></div>
                <div class="el-upload__tip" slot="tip">(請以 PDF 、JPG 格式之檔案上傳，檔案大小以 10MB 為限)</div>
              </el-upload>
            </td>
            <td style="vertical-align: top;">
              <el-button type="primary" size="small" @click="submit()" icon="el-icon-document" plain style="font-weight: bold;"
                          v-if="(null != fInfo) && (fInfo.status != 'R')">確定送出</el-button>
            </td>
          </tr>
        </table>
        
        <div
          v-if="(null != fInfo) && (fInfo.status != 'R')">
          <div class="pdf"
            v-if="fileType==2">
            <p class="arrow">
            頁數：<span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}" style="color: #207f4c; font-weight: bold;"
              v-if="1 < pageCount"><i class="el-icon-arrow-left"></i>{{$t('message.Preview_txt')}}</span>
            {{currentPage}} / {{pageCount}}
            <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}" style="color: #c1651a; font-weight: bold;"
              v-if="1 < pageCount">{{$t('message.NextPage_txt')}}<i class="el-icon-arrow-right"></i></span>
            </p>
                  <pdf scale="page-width" style="width:100%;margin:0.25em auto;border: 1px solid #BBCDC5 !important;"
                    :src="pdfDoc" 
                    :page="currentPage"
                    @num-pages="pageCount=$event"
                    @page-loaded="currentPage=$event"
                    @loaded="loadPdfHandler"></pdf>
          </div>
          <div class="viewer-wrapper" style="overflow:hidden;"
            v-if="fileType==1"> 
            <viewer :images="images"
              @inited="inited"
              class="viewer" ref="viewer">
              <template slot-scope="scope">
                <figure class="images">
                  <div class="image-wrapper" v-for="{source, thumbnail} in scope.images" :key="source">
                    <img class="image" style="max-width: 68em; max-height:80em;"
                      :src="thumbnail" :data-source="source" :alt="source.split('?image=').pop()"/>
                  </div>
                </figure> 
              </template>
            </viewer>
          </div>
        </div>           
        <div class="div-memo" >
          <div class="text-header title-text">考生申請資料</div>
          <section class="modal-body" id="modalDescription">
            <el-form ref="docRecord" :model="docRecord" label-width="130px" label-position="left" size="medium"
              v-if="null != docRecord">
              <!--<el-form-item style="margin-bottom: 1em;">
                </el-form-item> -->
              <el-form-item label="姓名" prop="stdName" style="border-bottom: 1px solid #a7a8bd;">
                {{docRecord.stdName}}
              </el-form-item> 
              <el-form-item label="申請學校" prop="schName" style="border-bottom: 1px solid #a7a8bd;">
                {{docRecord.schName}}
              </el-form-item> 
              <el-form-item label="申請系所" prop="deptName" style="border-bottom: 1px solid #a7a8bd;">
                {{docRecord.deptName}}
              </el-form-item> 
            </el-form>
          </section>
        </div>
      
        
      
  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  name: 'upload',
  components: {
    pdf
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    user () {
      return this.$store.getters.getUser
    },
    currentStatus() {
      var ret = '';
      if (null != this.docRecord) {          
        switch (this.docRecord.status) {
          case 3:
            ret = '已完成推薦，謝謝您！';
            break;
          case 2:
            ret = '已拒絶推薦...';
            break;
          default:
            ret = '您已同意推薦，請繼續上傳推薦檔案...';
            break;
        }
      }
      return ret;
    }
  },
  data () {
    return {
      docRecord: null,
      fInfo: null,
      fileList: [],
      pdfDoc: '',
      numPages: 0,
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 0,
      images: [],    
      img: '',
      options: {
        inline: true,
        button: true,
        navbar: false,
        title: false,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source'
      }
    }
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
    },
    changePdfPage (val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++
      }
    }, 
    loadPdfHandler (e) {
      this.currentPage = 1;
    },
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    handleExceed(files, fileList) {
      this.$message.warning('當前限制選擇 1 個檔');
    },
    beforeRemove(file, fileList) {
      return this.$confirm('確定移除 ${ file.name }？');
    },
    errorfun(res, file) {
      let vm = this;
      vm.$notify.error({
          title: vm.$t('message.Error_txt'),
          dangerouslyUseHTMLString: true,
          message: '<strong>檔案格式錯誤!</strong>',
          offset: 150
      });
    },
    handleAvatarSuccess(res, file) {
      var imgType = file.response[0].type == 'image/jpeg';
      var url = './WebApi/Tools/GetUpload/r'.concat(this.user.deptID).concat('.').concat(imgType? 'jpg': 'pdf').concat('/').concat(file.response[0].type);
      
      this.fInfo = file.response[0];
      if (imgType) {
        this.fileType = 1;
        this.images = [];
        this.images.push({
          thumbnail: url,
          source: url
        })
      } else {        
        this.fileType = 2;  
        this.pdfDoc = pdf.createLoadingTask(url);
        this.pdfDoc.then(pdf => {
          this.numPages = pdf.numPages;
        });
      }
    },
    onBeforeUpload(file)
    {
      this.fileData = file;
      var imgLst = ['image/jpeg', 'application/pdf'];
      //var imgLst = ['application/pdf'];
      var isPDF = true;
      
      const isLt10M = file.size / 1024 / 1024 < 10;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為 ";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isPDF = false;
        this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              message: msg,
                              offset: 150
                          });
      }
      if (!isLt10M) {
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: '檔案大小請勿超過 10MB!',
                            offset: 150
                          });
      }
      
      return (isPDF && isLt10M);      
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      var vm = this;
      if (null != this.fInfo) {
        if ('A' == this.fInfo.status) {
          this.fInfo.status = 'R';
        }
        this.$http.put('./WebApi/Tools/RemoveFiles',[this.fInfo])
                  .then((response) =>{
  
                  })
                  .catch(function (error) {
                        vm.$notify.error({
                                          title: vm.$t('message.Error_txt'),
                                          dangerouslyUseHTMLString: true,
                                          message: '<strong>對不起,網路連線失敗</strong>',
                                          offset: 150
                                        });
                  });
        
      }
    },
    submit() {
      var vm = this;
      this.$confirm("上傳完成，即完成推薦；確定要繼續上傳?", '請注意', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '確定送出',
          cancelButtonText: '取消'
        }).then(() => {
          var data = {
            documentId : vm.user.dId,
            recId: vm.user.deptID,
            info: [vm.fInfo]
          }
          vm.$http
              .put("./WebApi/Apply/SetRecLetter", data)
              .then(function(response) {
                if (response.data) { 
                  vm.query();
                }
              })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                offset: 150
                              });
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消送件'
          });          
        });
    }, 
    query() {
      var vm = this
      this.$http
          .get('./WebApi/Apply/GetCurrentRecData/'.concat(this.sysId).concat('/').concat(this.user.deptID))
          .then(function(response) {
            vm.docRecord = response.data
          })
          .catch(function (error) {
            //this.$message.error('對不起,網路連線失敗');
            vm.$notify.error({
              title: vm.$t('message.Error_txt'),
              dangerouslyUseHTMLString: true,
              message: '<strong>對不起,網路連線失敗' + error+'</strong>',
              offset: 150
            });
          })  
    }
  },
  created () {
    console.log('======created UploadView=====');
    this.query();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#others {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
  .div-memo {
    margin: 1em 0;
    position: relative;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
  }
  .text-header {
    font-weight: bolder;
    text-align: center;
    top: 30px;
    width: 110px;
    position: absolute;
    background: white;
  }
  .title-text {
    top: -0.8em;
    font-size: medium;
    font-weight: bolder;
    color: #1c2938;
  }
</style>



// WEBPACK FOOTER //
// src/components/UploadView.vue